<script lang="ts" setup>
import useOverlay from '@/legacy/ts/useOverlay'

const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
	isFullScreen: {
		type: Boolean,
		default: false,
	},
	isShowHeader: {
		type: Boolean,
		default: true,
	},
	canCloseDialogByOverlay: {
		type: Boolean,
		default: true,
	},
	isModalCenter: {
		type: Boolean,
		default: false,
	},
	isRevamp: {
		type: Boolean,
		defalut: false,
	},
	isForWebComponentShipping: {
		type: Boolean,
		default: false,
	},
})
const emit = defineEmits(['update:modelValue', 'on-hide'])
function updateModelValue(value: boolean) {
	emit('update:modelValue', value)
}

function onHide() {
	emit('on-hide')
}

const { isShow, hide } = useOverlay(props, updateModelValue, onHide)
function hideByClickOverlay() {
	if (props.canCloseDialogByOverlay) {
		hide()
	}
}
</script>

<template>
	<transition name="opacity">
		<aside
			v-show="isShow"
			:class="[
				'bs-dialog-full',
				{
					'full-screen': isFullScreen,
					headerless: !isShowHeader,
					'modal-center': isModalCenter,
					revamp: isRevamp,
				},
			]"
			role="dialog-full"
		>
			<div
				class="bs-overlay bs-overlay--full"
				@click="hideByClickOverlay"
			></div>
			<div class="bs-dialog-full-container">
				<div class="bs-dialog-full__header" v-if="isShowHeader">
					<button
						class="bs-icon bs-dialog-full__close"
						@click="hide"
						tabindex="0"
					>
						<span class="bs-dialog-full__close-icon"></span>
					</button>
					<slot name="header" />
				</div>
				<div
					:class="[
						'bs-dialog-full__body',
						{
							'px-8px py-32px mdl:px-16px mdl:pb-16px mdl:pt-0':
								isForWebComponentShipping,
						},
					]"
				>
					<slot name="content" />
				</div>
			</div>
		</aside>
	</transition>
</template>
